"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _jsxRuntime = require("react/jsx-runtime");

var TranslatedMultiMap = function TranslatedMultiMap(_ref) {
  var label = _ref.label,
      text = _ref.text,
      header = _ref.header,
      discriminator = _ref.discriminator,
      _ref$keys = _ref.keys,
      keys = _ref$keys === void 0 ? [] : _ref$keys;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;
  /**
   * Translates the keys based on the provided objects.
   * If the key is a string, it's translated using the 'i18next' library.
   * If the key is an object, it's handled by returning the 'name' properties.
   * @param {string[] | KeyType[]} keys - The keys to translate.
   * @return {string} The translated string.
   */


  var translateKeys = function translateKeys(keys) {
    return keys.map(function (key) {
      if (typeof key === 'string') {
        return t("profile-properties:".concat(discriminator || '', ".").concat((header === null || header === void 0 ? void 0 : header.tKey) || label, ".").concat(key));
      } else {
        // Modify this line to customize the display of the 'name'.

        /** Check if any key has value 'NONE' */
        for (var prop in key) {
          if (key[prop] === 'NONE') {
            return '';
          }
        }

        return t("profile-properties:".concat(discriminator || '', ".").concat((header === null || header === void 0 ? void 0 : header.tKey) || label, ".").concat(key.name));
      }
    }).filter(Boolean) // Remove empty strings
    .join(', ');
  };
  /**
   * Handles the main logic of the translation.
   * If 'text' is an array, it's passed to 'translateKeys'.
   * Otherwise, 'keys' is passed to 'translateKeys'.
   */


  var retVal = Array.isArray(text) ? translateKeys(text) : translateKeys(keys);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: retVal
  });
};

var _default = TranslatedMultiMap;
exports.default = _default;